import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';

const AnimateFromBottom = ({ children, delay = 0 }) => {
  const [ref, inView] = useInView({ threshold: 0.1 });
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    if (inView && !hasAnimated) {
      setHasAnimated(true);
    }
  }, [inView]);

  return (
    <div
      ref={ref}
      className={`animate-from-bottom ${hasAnimated ? 'animate' : ''}`}
      style={{ animationDelay: `${delay}s` }}
    >
      {children}
    </div>
  );
};

export default AnimateFromBottom;
